import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import useTranslation from "../../../../translations/use-translation";
import "./IdentityDetails.styles.scss";

const AADHAR_REGEX = /^\d{4}\s\d{4}\s\d{4}$/;
const PAN_REGEX    = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const validate = (identity) => {
  const errors = {};
  if (!identity.aadharNumber?.trim()) {
    errors.aadharNumber = 'Aadhaar number is required';
  } else if (!AADHAR_REGEX.test(identity.aadharNumber.trim())) {
    errors.aadharNumber = 'Enter a valid Aadhaar number (XXXX XXXX XXXX)';
  }
  if (!identity.panNumber?.trim()) {
    errors.panNumber = 'PAN number is required';
  } else if (!PAN_REGEX.test(identity.panNumber.trim().toUpperCase())) {
    errors.panNumber = 'Enter a valid PAN number (e.g. ABCDE1234F)';
  }
  return errors;
};

const formatAadhar = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 12);
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
};

const Req = () => <span className="identity-details__required">*</span>;

const IdentityDetails = ({ userProfile, setUserProfile }) => {
  const translate = useTranslation();
  const [errors, setErrors] = useState({});
  const [saved, setSaved]   = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === 'aadharNumber') value = formatAadhar(value);
    if (e.target.name === 'panNumber')    value = value.toUpperCase().slice(0, 10);

    setUserProfile([{
      personal:  { ...userProfile[0].personal },
      contacts:  { ...userProfile[0].contacts },
      education: { ...userProfile[0].education },
      identity:  { ...userProfile[0].identity, [e.target.name]: value },
    }]);
    if (errors[e.target.name]) {
      setErrors((prev) => { const { [e.target.name]: _, ...rest } = prev; return rest; });
    }
  };

  const handleSave = () => {
    const errs = validate(userProfile[0].identity);
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    try {
      const existing = JSON.parse(localStorage.getItem('userExtendedProfile') || '{}');
      localStorage.setItem('userExtendedProfile', JSON.stringify({
        ...existing,
        identity: userProfile[0].identity,
      }));
      setSaved(true);
      setErrors({});
      setTimeout(() => setSaved(false), 2500);
    } catch { /* storage full */ }
  };

  return (
    <div className="form-container">
      <div className="identity-form">
        <div className="form-title">Identity Details</div>

        <div className="identity-form__fields">
          <div className="identity-form__field">
            <label htmlFor="aadharNumber">{translate('AADHAR')} <Req /></label>
            <TextField
              name="aadharNumber"
              onChange={handleChange}
              value={userProfile[0]?.identity?.aadharNumber}
              id="aadharNumber"
              fullWidth
              variant="outlined"
              placeholder={translate('PLACEHOLDER_AADHAR')}
              error={!!errors.aadharNumber}
              helperText={errors.aadharNumber}
              inputProps={{ maxLength: 14 }}
            />
          </div>

          <div className="identity-form__field">
            <label htmlFor="panNumber">{translate('PAN')} <Req /></label>
            <TextField
              onChange={handleChange}
              id="panNumber"
              name="panNumber"
              value={userProfile[0].identity.panNumber}
              fullWidth
              variant="outlined"
              placeholder="ABCDE1234F"
              error={!!errors.panNumber}
              helperText={errors.panNumber}
              inputProps={{ maxLength: 10 }}
            />
          </div>
        </div>

        <div className="identity-save-btn">
          <Button variant="contained" onClick={handleSave}>
            {saved ? 'Saved!' : translate('SAVE')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IdentityDetails;
